import "css/formDIESIRResponsive.css";
import { resolveDiPdfFilename } from 'service/DiIdentity';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { ENDPOINT } from "constants/variables";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { warningErrorAction } from "actions/ErrorActions";
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import SendIcon from '@mui/icons-material/Send';
import PropTypes from 'prop-types';
import { LoadingNews } from "components/utils/LoadingNews";
import ReportTemplateFirst from 'pages/forms/esirFormDI/ReportTemplateFirst';
import ReportTemplateSecond from 'pages/forms/esirFormDI/ReportTemplateSecond';
import { addFormDIDecaQrToPdf, fetchFormDIDecaQr } from 'pages/forms/pdf/formDIDecaQr';
import esirIcon from "components/photos/sidebars/esir.svg.png";
import sedeElectronicaIcon from "components/photos/sidebars/sedeelectronica.png";
import "css/generalSettings.css";
import "css/customDialog.css";

const initialSateDialog = [{
  response: "",
  cause: "",
  status: ""
}];

const initialStateFromDISendEmail = {
  id: 0,
  ownformdi_id:0,
  defaultStore_id: 0,
  useraccount_id: 0, 
  defaultformatnumber: 1,
  isFinished: true,
  isScanned: false,
  preiddoc_sheet: "", 
  sufiddoc_sheet:0,
  number_dt: "",
  date_sheet: "",
 
  opt_tras_documnettype_entityFJCode: "",
  opt_tras_documentid: "",
  opt_tras_reason_reasonName: "",
  opt_tras_firstname: "",
  opt_tras_lastname1: "",
  opt_tras_lastname2: "",
  opt_tras_name: "", 
  opt_tras_contactname: "",
  opt_tras_reason_reasonAssociation_associationCode: "",
  opt_tras_reason_reasonAssociation_associationDescription: "",
  opt_tras_operatorTypeCode: "",
  opt_tras_operatorTypeDescription: "",
  opt_tras_country_countryCode: "",
  opt_tras_country_countryName: "",
  opt_tras_community_CACode: "",
  opt_tras_community_CAName: "",
  opt_tras_municipality_municipalityCode: "",
  opt_tras_municipality_municipalityName: "",
  opt_tras_province_provinceCode: "",
  opt_tras_province_provinceName: "",
  opt_tras_postalcode_localityCode: "",
  opt_tras_postalcode_localityName: "",
  opt_tras_roadtype_vialCode: "",
  opt_tras_roadtype_vialDescription: "",
  opt_tras_address: "",
  opt_tras_phone: "",
  opt_tras_mail: "",
  opt_tras_nima_centerCode: "",
  opt_tras_nima_centerDenomination: "",
  opt_tras_centerCNAE: "",
  opt_tras_centerEconomicActivity: "",
  opt_tras_pyGR: "",
  opt_tras_licenseplate: "",

  ori_tras_documnettype_entityFJCode: "",
  ori_tras_documentid: "",
  ori_tras_reason_reasonName: "",
  ori_tras_firstname: "",
  ori_tras_lastname1: "",
  ori_tras_lastname2: "",
  ori_tras_name: "",
  ori_tras_contactname: "", 
  ori_tras_reason_reasonAssociation_associationCode: "",
  ori_tras_reason_reasonAssociation_associationDescription: "",
  ori_tras_operatorTypeCode: "",
  ori_tras_operatorTypeDescription: "",
  ori_tras_country_countryCode: "",
  ori_tras_country_countryName: "",
  ori_tras_community_CACode: "",
  ori_tras_community_CAName: "",
  ori_tras_municipality_municipalityCode: "",
  ori_tras_municipality_municipalityName: "",
  ori_tras_province_provinceCode: "",
  ori_tras_province_provinceName: "",
  ori_tras_postalcode_localityCode: "",
  ori_tras_postalcode_localityName: "",
  ori_tras_roadtype_vialCode: "",
  ori_tras_roadtype_vialDescription: "",
  ori_tras_address: "",
  ori_tras_phone: "",
  ori_tras_mail: "",
  ori_tras_nima_centerCode: "",
  ori_tras_nima_centerDenomination: "",
  ori_tras_centerCNAE: "",
  ori_tras_centerEconomicActivity: "",
  ori_tras_pyGR: "",
  ori_tras_licenseplate: "",
    
  aut_tras_documnettype_entityFJCode: "",
  aut_tras_documentid: "",
  aut_tras_reason_reasonName: "",
  aut_tras_firstname: "",
  aut_tras_lastname1: "",
  aut_tras_lastname2: "",
  aut_tras_name: "",
  aut_tras_contactname: "",
  aut_tras_reason_reasonAssociation_associationCode: "",
  aut_tras_reason_reasonAssociation_associationDescription: "",
  aut_tras_operatorTypeCode: "",
  aut_tras_operatorTypeDescription: "",
  aut_tras_country_countryCode: "",
  aut_tras_country_countryName: "",
  aut_tras_community_CACode: "",
  aut_tras_community_CAName: "",
  aut_tras_municipality_municipalityCode: "",
  aut_tras_municipality_municipalityName: "",
  aut_tras_province_provinceCode: "",
  aut_tras_province_provinceName: "",
  aut_tras_postalcode_localityCode: "",
  aut_tras_postalcode_localityName: "",
  aut_tras_roadtype_vialCode: "",
  aut_tras_roadtype_vialDescription: "",
  aut_tras_address: "",
  aut_tras_phone: "",
  aut_tras_mail: "",
  aut_tras_nima_centerCode: "",
  aut_tras_nima_centerDenomination: "",
  aut_tras_centerCNAE: "",
  aut_tras_centerEconomicActivity: "",
  aut_tras_pyGR: "",
  aut_tras_licenseplate: "",
  
  dest_tras_documnettype_entityFJCode: "",
  dest_tras_documentid: "",
  dest_tras_reason_reasonName: "",
  dest_tras_firstname: "",
  dest_tras_lastname1: "",
  dest_tras_lastname2: "",
  dest_tras_name: "",
  dest_tras_contactname: "",
  dest_tras_reason_reasonAssociation_associationCode: "",
  dest_tras_reason_reasonAssociation_associationDescription: "",
  dest_tras_operatorTypeCode: "",
  dest_tras_operatorTypeDescription: "",
  dest_tras_country_countryCode: "",
  dest_tras_country_countryName: "",
  dest_tras_community_CACode: "",
  dest_tras_community_CAName: "",
  dest_tras_municipality_municipalityCode: "",
  dest_tras_municipality_municipalityName: "",
  dest_tras_province_provinceCode: "",
  dest_tras_province_provinceName: "",
  dest_tras_postalcode_localityCode: "",
  dest_tras_postalcode_localityName: "",
  dest_tras_roadtype_vialCode: "",
  dest_tras_roadtype_vialDescription: "",
  dest_tras_address: "",
  dest_tras_phone: "",
  dest_tras_mail: "",
  dest_tras_nima_centerCode: "",
  dest_tras_nima_centerDenomination: "",
  dest_tras_centerCNAE: "",
  dest_tras_centerEconomicActivity: "",
  dest_tras_pyGR: "",
  dest_tras_licenseplate: "",
 
  aut_dest_documnettype_entityFJCode: "",
  aut_dest_documentid: "",
  aut_dest_reason_reasonName: "",
  aut_dest_firstname: "",
  aut_dest_lastname1: "",
  aut_dest_lastname2: "",
  aut_dest_name: "",
  aut_dest_contactname: "",
  aut_dest_reason_reasonAssociation_associationCode: "",
  aut_dest_reason_reasonAssociation_associationDescription: "",
  aut_dest_operatorTypeCode: "",
  aut_dest_operatorTypeDescription: "",
  aut_dest_country_countryCode: "",
  aut_dest_country_countryName: "",
  aut_dest_community_CACode: "",
  aut_dest_community_CAName: "",
  aut_dest_municipality_municipalityCode: "",
  aut_dest_municipality_municipalityName: "",
  aut_dest_province_provinceCode: "",
  aut_dest_province_provinceName: "",
  aut_dest_postalcode_localityCode: "",
  aut_dest_postalcode_localityName: "",
  aut_dest_roadtype_vialCode: "",
  aut_dest_roadtype_vialDescription: "",
  aut_dest_address: "",
  aut_dest_phone: "",
  aut_dest_mail: "",
  aut_dest_nima_centerCode: "",
  aut_dest_nima_centerDenomination: "",
  aut_dest_centerCNAE: "",
  aut_dest_centerEconomicActivity: "",
  aut_dest_pyGR: "",
  aut_dest_licenseplate: "",
  
  rel_trans_documnettype_entityFJCode: "",
  rel_trans_documentid: "",
  rel_trans_name: "",
  rel_trans_contactname: "",
  rel_trans_reason_reasonName: "",
  rel_trans_firstname: "",
  rel_trans_lastname1: "",
  rel_trans_lastname2: "",
  rel_trans_reason_reasonAssociation_associationCode: "",
  rel_trans_reason_reasonAssociation_associationDescription: "",
  rel_trans_operatorTypeCode: "",
  rel_trans_operatorTypeDescription: "",
  rel_trans_country_countryCode: "",
  rel_trans_country_countryName: "",
  rel_trans_community_CACode: "",
  rel_trans_community_CAName: "",
  rel_trans_municipality_municipalityCode: "",
  rel_trans_municipality_municipalityName: "",
  rel_trans_province_provinceCode: "",
  rel_trans_province_provinceName: "",
  rel_trans_postalcode_localityCode: "",
  rel_trans_postalcode_localityName: "",
  rel_trans_roadtype_vialCode: "",
  rel_trans_roadtype_vialDescription: "",
  rel_trans_address: "",
  rel_trans_phone: "",
  rel_trans_mail: "",
  rel_trans_nima_centerCode: "",
  rel_trans_nima_centerDenomination: "",
  rel_trans_centerCNAE: "",
  rel_trans_centerEconomicActivity: "",
  rel_trans_pyGR: "",
  rel_trans_licenseplate: "",

  resp_prod_documnettype_entityFJCode: "",
  resp_prod_documentid: "",
  resp_prod_reason_reasonName: "",
  resp_prod_firstname: "",
  resp_prod_lastname1: "",
  resp_prod_lastname2: "",
  resp_prod_name: "",
  resp_prod_contactname: "", 
  resp_prod_reason_reasonAssociation_associationCode: "",
  resp_prod_reason_reasonAssociation_associationDescription: "",
  resp_prod_operatorTypeCode: "",
  resp_prod_operatorTypeDescription: "",
  resp_prod_country_countryCode: "",
  resp_prod_country_countryName: "",
  resp_prod_community_CACode: "",
  resp_prod_community_CAName: "",
  resp_prod_municipality_municipalityCode: "",
  resp_prod_municipality_municipalityName: "",
  resp_prod_province_provinceCode: "",
  resp_prod_province_provinceName: "",
  resp_prod_postalcode_localityCode: "",
  resp_prod_postalcode_localityName: "",
  resp_prod_roadtype_vialCode: "",
  resp_prod_roadtype_vialDescription: "",
  resp_prod_address: "",
  resp_prod_phone: "",
  resp_prod_mail: "",
  resp_prod_nima_centerCode: "",
  resp_prod_nima_centerDenomination: "",
  resp_prod_centerCNAE: "",
  resp_prod_centerEconomicActivity: "",
  resp_prod_pyGR: "",
  resp_prod_licenseplate: "",
 
  codeler_code: "",
  codeler_name: "",
  description_code: "",
  description_name: "",
  treatmenttypeorigin_code: "",
  treatmenttypeorigin_name: "",
  treatmenttypedestine_code: "",
  treatmenttypedestine_name: "",
  processtypepeorigin_code: "",
  processtypepeorigin_name: "",
  processtypedestine_code: "",
  processtypedestine_name: "",
  dangerousness_name: "",
  charac_danger: "",
  amount: 0,
  deliver_date: "",
  delivery_quantity: 0,
  accept: "",
  date_accepted: "",
  date_refund: "",
  reason_refund: "",
  action_refund: "",
  observations1: "",
  observations2: "" ,
  
  signature_opt_tras:"",
  signature_dest_tras:"",
  signature_refund:"",
  
  checked_numberDI_sheet:false,
  checked_date_sheet:false,
  checked_opt_tras_documentid:false,
  checked_opt_tras_tradename:false,
  checked_opt_tras_street:false,
  checked_opt_tras_locality:false,
  checked_opt_tras_nima:false,
  checked_opt_tras_opt:false,
  checked_opt_tras_inscription:false,
  checked_ori_tras_documentid:false,
  checked_ori_tras_tradename:false,
  checked_ori_tras_street:false,
  checked_ori_tras_locality:false,
  checked_ori_tras_nima:false,
  checked_ori_tras_opt:false,
  checked_ori_tras_inscription:false,
  checked_dest_tras_documentid:false,
  checked_dest_tras_tradename:false,
  checked_dest_tras_street:false,
  checked_dest_tras_locality:false,
  checked_dest_tras_nima:false,
  checked_dest_tras_opt:false,
  checked_dest_tras_inscription:false,
  checked_rel_trans_documentid:false,
  checked_rel_trans_tradename:false,
  checked_rel_trans_street:false,
  checked_rel_trans_locality:false,
  checked_rel_trans_nima:false,
  checked_rel_trans_opt:false,
  checked_rel_trans_inscription:false,
  checked_aut_tras_opt:false,
  checked_aut_dest_opt:false,
  checked_resp_prod_opt:false,
  checked_codeLER:false,
  checked_amount:false,
  checked_dateDelivery:false,
  checked_amountDelivery:false,
  hasbeensent:false,
  hasbeensentesir:false,
  hasbeenshared:false

}; 
 
const REQUIRED_CHECKS = [
  "checked_numberDI_sheet",
  "checked_date_sheet",

  "checked_opt_tras_documentid",
  "checked_opt_tras_tradename",
  "checked_opt_tras_street",
  "checked_opt_tras_locality",
  "checked_opt_tras_nima",
  "checked_opt_tras_opt",
  "checked_opt_tras_inscription",

  "checked_ori_tras_documentid",
  "checked_ori_tras_tradename",
  "checked_ori_tras_street",
  "checked_ori_tras_locality",
  "checked_ori_tras_nima",
  "checked_ori_tras_opt",
  "checked_ori_tras_inscription",

  "checked_dest_tras_documentid",
  "checked_dest_tras_tradename",
  "checked_dest_tras_street",
  "checked_dest_tras_locality",
  "checked_dest_tras_nima",
  "checked_dest_tras_opt",
  "checked_dest_tras_inscription",

  "checked_rel_trans_documentid",
  "checked_rel_trans_tradename",
  "checked_rel_trans_street",
  "checked_rel_trans_locality",
  "checked_rel_trans_nima",
  "checked_rel_trans_opt",
  "checked_rel_trans_inscription",

  "checked_codeLER",
  "checked_amount",
]; 
const CheckboxLine = React.memo(function CheckboxLine({ checked, label }) {
  return (
    <div className="esir-check-line">
      <Checkbox
        checked={!!checked}
        sx={{ '& .MuiSvgIcon-root': { color: "#4e73df", fontSize: 28 } }}
        disabled
      />
      <label className="text-primary" style={{ fontSize: 18 }}>
        {label}
      </label>
      
    </div>
  );
}); 

const FormDISendESIR = ({ id, showModalFormDISendESIR, typeOfList }) => {
  const { t } = useTranslation(['listDataForms']);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.loginUser.token);
  const defaulttypesdi = useSelector((state) => state.loginUser.defaulttypesdi.formatnumber);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [dataForm, setDataForm] = useState(initialStateFromDISendEmail);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [pdfUrl, setPdfUrl] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState(initialSateDialog);
  const [hasSuccess, setHasSuccess] = useState(false); 
  const checklistState = useMemo(() => {
    return REQUIRED_CHECKS.every(k => !!dataForm[k]);
  }, [dataForm]);
 
  useEffect(() => {
    if (!pdfBlob) return;
    const url = URL.createObjectURL(pdfBlob);
    setPdfUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [pdfBlob]);
 
  const resetState = useCallback(() => {
    setDataForm(initialStateFromDISendEmail);
    setPdfBlob(null);
    setPdfUrl("");
    setDialogOpen(false);
    setDialogMessage(initialSateDialog);
    setHasSuccess(false);
    dispatch(setLoading(false));
  }, [dispatch]);

  const handleCloseSendESIR = useCallback(() => {
    resetState();
    navigate(typeOfList === "1" ? "/formdi" : "/formdiended");
  }, [resetState, navigate, typeOfList]);
 
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape' && showModalFormDISendESIR) {
        handleCloseSendESIR();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [showModalFormDISendESIR, handleCloseSendESIR]);

  const validateForm = useCallback(() => {
    return REQUIRED_CHECKS.every(k => !!dataForm[k]);
  }, [dataForm]);

  const handleSubmitSendESIR = async () => {
    if (!validateForm()) { 
      setDialogMessage(initialSateDialog);
      setDialogOpen(false);
      return;
    }
    dispatch(setLoading(true));
    setDialogOpen(true);
    try {
      const response = await helpHttp().post(ENDPOINT, `api/esir/send-xml`, token, dataForm);
      if (response) {
        setHasSuccess(response.some(entry =>
          entry.cause === "Text_Form_Saved" || entry.cause === "Text_SaveData"
        ));
        setDialogMessage(response);
      } else {
        setDialogMessage(initialSateDialog);
        dispatch(warningErrorAction(t('Text_ConnectionFailed')));
      }
    } catch {
      setDialogMessage([{ status: "ERROR", cause: "Text_ConnectionFailed", response: "" }]);
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    if (id === "0") {
      setDataForm(initialStateFromDISendEmail);
      dispatch(setLoading(false));
      return;
    }
    let alive = true;
    const fetchData = async () => {
      if (!alive) return;
      dispatch(setLoading(true));
      try {
        const data = await helpHttp().get11(
          ENDPOINT,
          `api/esir/getpdfformdibyid`,
          token,
          id,
          defaulttypesdi
        );
        if (!alive) return;
        if (data?.err) {
          setDataForm(initialStateFromDISendEmail);
          dispatch(warningErrorAction(t('Text_ConnectionFailed')));
          return;
        }
        const decaQrDataUrl = data?.hasDeCA
          ? await fetchFormDIDecaQr(data?.id || id, token)
          : '';
        if (!alive) return;
        setDataForm({ ...data, decaQrDataUrl });
        if (data?.isScanned) {
          setPdfBlob(null);
          setPdfUrl("");
          const diNumber = `${(data.preiddoc_sheet || "").trim()}${data.sufiddoc_sheet ?? ""}`;
          if (!diNumber) return;
          const fileName = await resolveDiPdfFilename(ENDPOINT,token,data.id);
          const file = await helpHttp().getfilesupload(
            ENDPOINT,
            `pdftos3uploader/downloadfroms3`,
            token,
            fileName
          );
          if (!alive) return;
          if (file?.size > 0) {
            setPdfBlob(await addFormDIDecaQrToPdf(file, decaQrDataUrl));
          } else {
            setPdfUrl("");
          }
        }
      } catch (e) {
        if (!alive) return;
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      } finally {
        if (!alive) return;
        dispatch(setLoading(false));
      }
    };
    fetchData();
    return () => {
      alive = false;
    };
  }, [id, token, defaulttypesdi, dispatch, t]);

  if (!showModalFormDISendESIR) return null;
  return (
    <div className="container-fluid email-send-wrapper formdi-esir-form">
      <Box sx={{ bgcolor: '#ffffff', width: '100%' }}>
        {/* HEADER */}
        <div className="formgeneral-card-header">
          <div className="formgeneral-header-content">
            <div className="formgeneral-header-title2">
              {isLoadingData ? (
                <CircularProgress sx={{ color: "#f6c23e" }} />
              ) : (
                <>
                  <img
                    src={sedeElectronicaIcon}
                    alt="sedeElectronicaIcon"
                    style={{
                      width: "80px",
                      height: "50px",
                      verticalAlign: "middle",
                      backgroundColor: "white",
                      borderRadius: "4px",
                      padding: "2px"
                    }}
                  />
                  &nbsp;&nbsp;{(dataForm.preiddoc_sheet || "").trim() + dataForm.sufiddoc_sheet}
                </>
              )}
            </div>
            <div className="email-card-actions">
              {isLoadingData ? (
                <CircularProgress sx={{ color: "#f6c23e" }} />
              ) : (
                <>
                  <button
                    type="button"
                    className={!checklistState ? "esir-nosend-btn" : "esir-send-btn"}
                    onClick={handleSubmitSendESIR}
                    disabled={!checklistState}
                  >
                    <img
                      src={esirIcon}
                      alt="e-SIR"
                      style={{
                        width: 80,
                        height: 30,
                        backgroundColor: !checklistState ? "rgb(234, 233, 233)" : "white",
                        verticalAlign: "middle",
                        borderRadius: "6px",
                        padding: "2px"
                      }}
                    />
                    &nbsp;
                    <SendIcon sx={{ fontSize: 28, color: !checklistState ? "rgba(95, 94, 92, 0.5)" : "#df974e" }} />
                  </button>
                  &nbsp;
                  <button type="button" className="formgeneral-cancel-btn" onClick={handleCloseSendESIR}>
                    {t('Button_Cancel')}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
        <br />
        <form className="createform" onSubmit={(e) => { e.preventDefault(); handleCloseSendESIR(); }}>
          {!isLoadingData ? (
            <>
              <div className="email-card-form">
                <div className="row p-4">
                  <div className="email-card-title2">
                    <h3 className="mb-3 fw-bold" style={{ color: "#df974e", fontSize: 28 }}>
                      {t("Text_Requirements_TITTLE")}
                    </h3>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <CheckboxLine checked={dataForm.checked_numberDI_sheet} label={t('Text_FORM_Requirements_NUM_DI').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_date_sheet} label={t('Text_FORM_Requirements_DATE').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_codeLER} label={t('SubMenu_Settings_Type_CodeLers').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_amount} label={t('Text_FORM_AMOUNT').toUpperCase()} />
                      </div> 
                      <h5 className="mb-3 text fw-bold" style={{ color: "#df974e", fontSize: 20 }}>
                        {t("Text_FORM_Requirements_OPT_TRAS")}
                      </h5>
                      <hr className="sidebar-divider d-none d-md-block" /> 
                      <div className="form-group">
                        <CheckboxLine checked={dataForm.checked_opt_tras_documentid} label={t('Text_FORM_Requirements_CIF').toUpperCase()} />
                        <CheckboxLine
                          checked={dataForm.checked_opt_tras_tradename}
                          label={(dataForm.opt_tras_documnettype_entityFJCode === "J"
                            ? t('Text_FORM_Requirements_TRADENAME')
                            : t('Text_FORM_Requirements_FIRSTNAME')
                          ).toUpperCase()}
                        />
                        <CheckboxLine checked={dataForm.checked_opt_tras_street} label={t('Text_FORM_Requirements_Address').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_opt_tras_locality} label={t('Text_FORM_Requirements_PostalCode').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_opt_tras_nima} label={t('Text_FORM_Requirements_NIMA').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_opt_tras_opt} label={t('Text_FORM_Requirements_OPT').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_opt_tras_inscription} label={t('Text_FORM_Requirements_INSCRIPTION').toUpperCase()} />
                      </div>
                    </div> 
                    <div className="col-md-4">
                      <h5 className="mb-3 text fw-bold" style={{ color: "#df974e", fontSize: 20 }}>
                        {t("Text_FORM_Requirements_ORI_TRAS")}
                      </h5>
                      <hr className="sidebar-divider d-none d-md-block" /> 
                      <div className="form-group">
                        <CheckboxLine checked={dataForm.checked_ori_tras_documentid} label={t('Text_FORM_Requirements_CIF').toUpperCase()} />
                        <CheckboxLine
                          checked={dataForm.checked_ori_tras_tradename}
                          label={(dataForm.ori_tras_documnettype_entityFJCode === "J"
                            ? t('Text_FORM_Requirements_TRADENAME')
                            : t('Text_FORM_Requirements_FIRSTNAME')
                          ).toUpperCase()}
                        />
                        <CheckboxLine checked={dataForm.checked_ori_tras_street} label={t('Text_FORM_Requirements_Address').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_ori_tras_locality} label={t('Text_FORM_Requirements_PostalCode').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_ori_tras_nima} label={t('Text_FORM_Requirements_NIMA').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_ori_tras_opt} label={t('Text_FORM_Requirements_OPT').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_ori_tras_inscription} label={t('Text_FORM_Requirements_INSCRIPTION').toUpperCase()} />
                      </div>
                      <h5 className="mb-3 text fw-bold" style={{ color: "#df974e", fontSize: 20 }}>
                        {t("Text_FORM_Requirements_DEST_TRAS")}
                      </h5>
                      <hr className="sidebar-divider d-none d-md-block" /> 
                      <div className="form-group">
                        <CheckboxLine checked={dataForm.checked_dest_tras_documentid} label={t('Text_FORM_Requirements_CIF').toUpperCase()} />
                        <CheckboxLine
                          checked={dataForm.checked_dest_tras_tradename}
                          label={(dataForm.dest_tras_documnettype_entityFJCode === "J"
                            ? t('Text_FORM_Requirements_TRADENAME')
                            : t('Text_FORM_Requirements_FIRSTNAME')
                          ).toUpperCase()}
                        />
                        <CheckboxLine checked={dataForm.checked_dest_tras_street} label={t('Text_FORM_Requirements_Address').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_dest_tras_locality} label={t('Text_FORM_Requirements_PostalCode').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_dest_tras_nima} label={t('Text_FORM_Requirements_NIMA').toUpperCase()} />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <CheckboxLine checked={dataForm.checked_dest_tras_opt} label={t('Text_FORM_Requirements_OPT').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_dest_tras_inscription} label={t('Text_FORM_Requirements_INSCRIPTION').toUpperCase()} />
                      </div>
                      <h5 className="mb-3 text fw-bold" style={{ color: "#df974e", fontSize: 20 }}>
                        {t("Text_FORM_Requirements_Carrier")}
                      </h5>
                      <hr className="sidebar-divider d-none d-md-block" />
                      <div className="form-group">
                        <CheckboxLine checked={dataForm.checked_rel_trans_documentid} label={t('Text_FORM_Requirements_CIF').toUpperCase()} />
                        <CheckboxLine
                          checked={dataForm.checked_rel_trans_tradename}
                          label={(dataForm.rel_trans_documnettype_entityFJCode === "J"
                            ? t('Text_FORM_Requirements_TRADENAME')
                            : t('Text_FORM_Requirements_FIRSTNAME')
                          ).toUpperCase()}
                        />
                        <CheckboxLine checked={dataForm.checked_rel_trans_street} label={t('Text_FORM_Requirements_Address').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_rel_trans_locality} label={t('Text_FORM_Requirements_PostalCode').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_rel_trans_nima} label={t('Text_FORM_Requirements_NIMA').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_rel_trans_opt} label={t('Text_FORM_Requirements_OPT').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_rel_trans_inscription} label={t('Text_FORM_Requirements_INSCRIPTION').toUpperCase()} />
                      </div>
                      <h5 className="mb-3 text fw-bold" style={{ color: "#df974e", fontSize: 20 }}>
                        {t("Text_FORM_ACCEPTED")}
                      </h5>
                      <hr className="sidebar-divider d-none d-md-block" />
                      <div className="form-group">
                        <CheckboxLine checked={dataForm.checked_amountDelivery} label={t('Text_FORM_Delivery_quantity').toUpperCase()} />
                        <CheckboxLine checked={dataForm.checked_dateDelivery} label={t('Text_FORM_Deliver').toUpperCase()} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="email-card-pdf">
                {pdfUrl ? (
                  <iframe
                    src={pdfUrl}
                    title="PDF Preview"
                    style={{ width: '100%', height: '100%', border: 'none' }}
                  />
                ) : null}
              </div>
            </>
          ) : (
            <LoadingNews />
          )}
        </form>
      </Box>
      {!pdfUrl && !isLoadingData && dataForm.id !== 0 && (
        defaulttypesdi === 1 ? (
          <ReportTemplateFirst dataForm={dataForm} setPdfBlob={setPdfBlob} />
        ) : (
          <ReportTemplateSecond dataForm={dataForm} setPdfBlob={setPdfBlob} />
        )
      )}
      <Dialog
        open={dialogOpen && !isLoadingData}
        onClose={handleCloseSendESIR}
        maxWidth="md"
        fullWidth
        classes={{
          paper: hasSuccess ? "esir-dialog-paper success" : "esir-dialog-paper error"
        }}
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { className: "esir-dialog-backdrop" } }}
      >
        <DialogTitle
          className={`esir-dialog-title ${hasSuccess ? "esir-dialog-title--ok" : "esir-dialog-title--error"}`}
        >
          {hasSuccess ? t("Text_Successful_Send") : t("TextResulut_Send")}
          <small>{dataForm.preiddoc_sheet}{dataForm.sufiddoc_sheet}</small>
        </DialogTitle>
        <div className="esir-dialog-titlebar" />
        <DialogContent dividers className="esir-dialog-content">
          <div className="esir-dialog-content-inner">
            <ul className="esir-dialog-list">
              {(dialogMessage || []).map((item, idx) => (
                <li
                  key={idx}
                  className={`esir-dialog-item ${item.status === "OK" ? "ok" : "error"}`}
                >
                  {t(item.cause)}
                </li>
              ))}
            </ul>
          </div>
        </DialogContent>
        {!isLoadingData && (
          <DialogActions className="esir-dialog-actions">
            <Button
              variant="contained"
              disableElevation
              onClick={handleCloseSendESIR}
              className={`esir-dialog-btn-close ${hasSuccess ? 'success' : ''}`}
            >
              {t('Button_Exit')}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
};

FormDISendESIR.propTypes = {
  id: PropTypes.string.isRequired,
  showModalFormDISendESIR: PropTypes.bool.isRequired,
  typeOfList: PropTypes.string
};

export default FormDISendESIR;
